import React, { useContext } from "react";
import { Skeleton } from "primereact/skeleton";
import { ContactProfileDetailsContext } from "app/uicomponents/macrocomponents/ContactLayout";
import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";

function ContactDashBoardHeader() {
  const { contactFirstName, isOpen } = useContext(ContactProfileDetailsContext);
  const { isDarkMode } = useContext(ThemeContext);
  return (
    <div
      style={{
        height: "80px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="w-full fixed z-50"
    >
      {/* Reserves the sidebar's width - keep in step with ContactLeftPanel. */}
      <div className={`h-full ${isOpen ? "w-2/12" : "w-1/10"}`} />
      {/* The divider spans the content column only - it must not run under the sidebar. */}
      <div className="h-full border-bottom-1 border-[#DEE2E6]" style={{ flex: isOpen ? 4 : 6 }}>
        <div className="flex justify-between items-center h-full conthrax-font">
          {contactFirstName ? (
            <p
              className={`text-2xl font-semibold py-3 ${!isOpen ? "ml-5" : ""}`}
              style={{ color: isDarkMode ? "#FFFFFF" : "#0A090B" }}
            >
              {`Welcome Back, ${contactFirstName}!`}
            </p>
          ) : (
            <Skeleton width="20rem" height="3rem" borderRadius="16px" className="mb-2" />
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactDashBoardHeader;
